import React from "react";

const EnviornmentsComponent = () => {
    return (
        <article className="docs-article" id="section-3">
            <header className="docs-header">
                <h1 className="docs-heading">Environments <span className="docs-time">Last updated: 2023-06-30</span>
                </h1>
                <section className="docs-intro">
                    <p>
                        In our system, we have two main environments: UAT (User Acceptance Testing) and production. UAT is a dedicated testing environment where merchants can evaluate and validate the functionality of our APIs before deploying them to the live production environment. The base API URL for the UAT environment is <span style={{ fontWeight: "bold" }}>https://demo-api.westpay.se/</span>.
                    </p>
                    <br />
                    <p>
                        On the other hand, the production environment is the live, operational environment where merchants use our APIs to process real transactions. It is the environment where the actual financial transactions take place. The base API URL for the production environment is <span style={{ fontWeight: "bold" }}>https://api.westpay.se/</span>.
                    </p>
                    <br />
                    <p>
                        By providing separate environments, we ensure a controlled testing environment in UAT and a stable, secure environment for production transactions, allowing merchants to confidently utilize our APIs in both testing and live scenarios.
                    </p>
                </section>
            </header>
        </article>
    )
}

export default EnviornmentsComponent;